<div class="field-with-hotkeys" (focusin)="onFocus()" (focusout)="onBlur()">
  <div #labelButtonsRow class="label-buttons-row" *ngIf="isIntakeForm && showHotkeys">
    <div class="hotkey-symbols">
      <button
        type="button"
        *ngIf="field?.formControl?.valid"
        [class]="compactMode ? 'hotkey-button compact' : 'hotkey-button'"
        aria-label="Next question"
        [matTooltip]="compactMode ? 'Next question' : null"
        matTooltipPosition="above"
      >
        <ng-container *ngIf="!compactMode">
          <span class="hotkey-label">Next question</span>
        </ng-container>
        <span class="hotkey-icon-group">
          <img src="/assets/icons/tab.svg" alt="Tab" />
        </span>
      </button>
      <span *ngIf="compactMode && field?.formControl?.valid && isSectionValid()" class="separator">/</span>
      <button
        type="button"
        *ngIf="isSectionValid()"
        [class]="compactMode ? 'hotkey-button compact' : 'hotkey-button'"
        aria-label="Next section"
        [matTooltip]="compactMode ? 'Next section' : null"
        matTooltipPosition="above"
      >
        <ng-container *ngIf="!compactMode">
          <span class="hotkey-label">Next section</span>
        </ng-container>
        <span class="hotkey-icon-group mr-1">
          <img src="/assets/icons/shift.svg" alt="Shift key" />
        </span>
        <span class="hotkey-icon-group">
          <img src="/assets/icons/enter.svg" alt="Enter key" />
        </span>
      </button>
    </div>
  </div>

  <div #inputWrapper class="input-wrapper">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>